// 搜索类别
export const optionType = [
  {
    value: "1",
    label: "订单号后五位",
  },
  {
    value: "2",
    label: '订单号',
  },
  {
    value: "3",
    label: '交易号',
  },
  {
    value: "4",
    label: '物流单号',
  },
]

// 搜索类别
export const receiveStatus = [
  {
    value: "",
    label: "全部",
  },
  {
    value: "1",
    label: "紧急件",
  },
  {
    value: "2",
    label: '拒收件',
  },
  {
    value: "3",
    label: '验货件',
  },
  {
    value: "4",
    label: '系统件',
  },
  {
    value: "5",
    label: '平台件',
  },
]

// 搜索类别
export const urgentStatus = [

  {
    value: "1",
    label: "紧急件",
  },
  {
    value: "2",
    label: '拒收件',
  },
  {
    value: "3",
    label: '验货件',
  },

]

// 箱子格式
export const attrOption = [
  { value: '58*51*50', label: '58*51*50', },
  { value: '50*40*30', label: '50*40*30', },
  { value: '60*40*50', label: '60*40*50' },
  { value: '50*30*20', label: '50*30*20' },
  { value: '30*20*20', label: '30*20*20' },
  { value: '80*55*35', label: '80*55*35' },
]

// 发票状态
export const invoiceStatus = [
  {
    value: "未保存",
    label: "未保存",
  },
  {
    value: "临时保存",
    label: '临时保存',
  },
  {
    value: "可下载",
    label: '可下载',
  },
  {
    value: "暂时发货",
    label: '暂时发货',
  },
  {
    value: "已下载",
    label: '已下载',
  },
]

// 唛头状态
export const shippingMarkStatus = [
  {
    value: "唛头待打印",
    label: "唛头待打印",
  },
  {
    value: "唛头已打印",
    label: "唛头已打印",
  },
  {
    value: "部分打印",
    label: '部分打印',
  },
]

// 售后单类型
export const afterSaleCategory = [
  {
    value: "1",
    label: "整个单子售后",
  },
  {
    value: "2",
    label: "具体商品售后",
  },

]

// 赔款状态筛选
export const indemnityStatus = [
  {
    value: "未提出",
    label: "未提出",
  },
  {
    value: "待确认",
    label: "待确认",
  },
  {
    value: "已确认",
    label: '已确认',
  },
]

// 赔款状态筛选
export const liable_type = [
  {
    value: "未提出",
    label: "未提出",
  },
  {
    value: "待确认",
    label: "待确认",
  },
  {
    value: "已确认",
    label: '已确认',
  },
]

export const options = [
  {
    value: '',
    label: '全部'
  },
  {
    value: '1',
    label: '纯中文'

  },
  {
    value: '2',
    label: '包含中文'
  },
  {
    value: '3',
    label: '不包含中文'
  },
]
// 会员VIP
export const vipList = [
  {
    value: '0',
    label: '普通客户'
  },

  {
    value: '1',
    label: '付费会员'
  },
  {
    value: '2',
    label: 'SVIP'

  },
  {
    value: '3',
    label: '潜力客户'
  },
]

// 是否授权
export const authorized = [
  {
    value: "0",
    label: "未授权",
  },
  {
    value: "1",
    label: "已授权",
  },

]

//赔款类型
export const reparationType = [
  {
    value: "默认",
  },
  {
    value: "精检",
  },
  {
    value: "普检",
  },
  {
    value: "缝标",
  },
  {
    value: "FBA",
  },

]

// 付完款订单状态
export const orderType = [
  {
    value: "全部",
    num: 0,
  },
  {
    value: "待采购",
    num: 0,
  },
  {
    value: "待财务付款",
    num: 0,
  },
  {
    value: "待发货",
    num: 0,
  },
  {
    value: "已发货",
    num: 0,
  },
  {
    value: "已签收",
    num: 0,
  },
  {
    value: "核查中",
    num: 0,
  },
  {
    value: "检品中",
    num: 0,
  },
  {
    value: "检品完了",
    num: 0,
  },
  {
    value: "上架中",
    num: 0,
  },
  {
    value: "上架完了",
    num: 0,
  },
  {
    value: "发货完了",
    num: 0,
  },

]
// 采购处理类别
export const g_deal_type = [
  { key: '退货退款' },
  { key: '换货' },
  { key: '丢货重拍' },
  { key: '少货补买' },
  { key: '其他' },
  { key: '仅退款' },
]


